import React, { forwardRef, Fragment } from 'react'
import PropTypes from 'prop-types'
import { classNames, elementAttributes } from '@zambezi/sdk/common'

/**
 * Create a React InputWrapper component
 *
 * @param {import('./interfaces').InputWrapperProps} props
 * @param {import('react').Ref} ref
 * @returns {JSX.Element}
 */
function inputWrapper (props, ref) {
  const {
    value,
    disabled,
    error,
    className,
    onKeyPress,
    onKeyDown,
    onKeyUp,
    onMouseDown,
    onClick,
    onMouseUp,
    onBlur,
    onFocus,
    onChange,
    withLabel,
    checked,
    focused,
    type,
    title,
    rootClassName,
    children
  } = props
  const inputProps = elementAttributes(props, {
    className: `${rootClassName}-input`,
    disabled,
    type,
    value,
    checked,
    onBlur,
    onFocus,
    onChange,
    onKeyPress,
    onKeyDown,
    onKeyUp,
    ref,
    'aria-invalid': !!error,
    'aria-checked': !!checked
  })

  return (
    <Fragment>
      <span
        className={classNames(
          rootClassName,
          checked && `${rootClassName}-is-checked`,
          focused && `${rootClassName}-is-focused`,
          disabled && `${rootClassName}-is-disabled`,
          error && `${rootClassName}-is-error`,
          !withLabel && className
        )}
        aria-hidden='true'
        onMouseDown={onMouseDown}
        onClick={onClick}
        onMouseUp={onMouseUp}
        title={title}
      >
        {children}
      </span>
      <input {...inputProps} />
    </Fragment>
  )
}

const InputWrapper = forwardRef(inputWrapper)

InputWrapper.displayName = 'InputWrapper'

InputWrapper.propTypes = {
  checked: PropTypes.bool,
  focused: PropTypes.bool,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  value: PropTypes.string,
  type: PropTypes.string.isRequired,
  rootClassName: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onKeyPress: PropTypes.func,
  onKeyDown: PropTypes.func,
  onKeyUp: PropTypes.func,
  onMouseDown: PropTypes.func,
  onMouseUp: PropTypes.func,
  onClick: PropTypes.func,
  className: PropTypes.string,
  withLabel: PropTypes.bool
}

export default InputWrapper
